module.exports = __webpack_public_path__ + "img/avatar4.cc9daea5.png";